var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 122.19 132.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#6e63fb;}.cls-3{fill:#2f2bb2;}.cls-4{fill:#fff;}.cls-5{fill:#3f3d55;}.cls-6,.cls-9{opacity:0.5;}.cls-6,.cls-8,.cls-9{mix-blend-mode:multiply;}.cls-7{fill:#00356b;}.cls-8{opacity:0.3;fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:#1969ff;mix-blend-mode:screen;}.cls-11{fill:#5552e2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 83.85,
    y1: 207.32,
    x2: 85.01,
    y2: 205.93,
    gradientTransform: "matrix(1, 0, 0, -1, 243.03, 410.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#014384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4273a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#84a4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#b9cbdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#dfe7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f6f9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 83.42,
    y1: 203.46,
    x2: 86.14,
    y2: 206.28,
    gradientTransform: "matrix(1, 0, 0, -1, 243.03, 410.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#014384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4273a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#84a4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b9cbdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#dfe7f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#f6f9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.78 131.66 21.62 125.4 4.61 125.4 6.78 131.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.21,250.73h-1.77a.61.61,0,0,1-.61-.54L290,243.5l7.19-.16-3.44,7A.61.61,0,0,1,293.21,250.73Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.42 131.66 100.58 125.4 117.58 125.4 115.42 131.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.07,250.73h1.77a.61.61,0,0,0,.61-.54l.81-6.69-7.18-.16,3.43,7A.62.62,0,0,0,256.07,250.73Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.55,
    y: 0.5,
    width: 121.07,
    height: 125.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 6.17,
    y: 5.75,
    width: 109.82,
    height: 116.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.28,
    y: 6.91,
    width: 107.62,
    height: 114.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.47,
    y: 9.64,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.9,
    y: 9.75,
    width: 8.56,
    height: 4.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4.61,
    y: 10.5,
    width: 3.41,
    height: 2.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.47,
    y: 114.17,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.43,
    y: 114.28,
    width: 8.56,
    height: 4.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.61,
    y: 115.03,
    width: 3.41,
    height: 2.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.47,
    y: 84.59,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.8,
    y: 84.7,
    width: 8.56,
    height: 4.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.61,
    y: 85.45,
    width: 3.41,
    height: 2.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.47,
    y: 39.33,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.9,
    y: 39.44,
    width: 8.56,
    height: 4.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.61,
    y: 40.2,
    width: 3.41,
    height: 2.98
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 111.72,
    y: 9.75,
    width: 8.56,
    height: 4.49
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116,
    y: 9.64,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.27,
    y: 128.3,
    width: 8.56,
    height: 4.49,
    transform: "translate(445.55 142.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 326.74,
    y: 129.12,
    width: 3.41,
    height: 2.98,
    transform: "translate(443.34 142.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116,
    y: 114.17,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.39,
    y: 232.83,
    width: 8.56,
    height: 4.49,
    transform: "translate(445.78 351.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 326.65,
    y: 233.59,
    width: 3.41,
    height: 2.98,
    transform: "translate(443.16 351.6) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116,
    y: 84.59,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.46,
    y: 203.25,
    width: 8.56,
    height: 4.49,
    transform: "translate(445.91 292.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 326.71,
    y: 204,
    width: 3.41,
    height: 2.98,
    transform: "translate(443.27 292.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 326.71,
    y: 204,
    width: 3.41,
    height: 2.98,
    transform: "translate(443.27 292.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 326.71,
    y: 204,
    width: 3.41,
    height: 2.98,
    transform: "translate(443.27 292.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 116,
    y: 39.33,
    width: 4.7,
    height: 4.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 325.27,
    y: 158,
    width: 8.56,
    height: 4.49,
    transform: "translate(445.55 201.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 326.14,
    y: 158.75,
    width: 3.41,
    height: 2.98,
    transform: "translate(442.14 201.93) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 328.97,
    y: 118.55,
    width: 6.78,
    height: 6.78,
    rx: 0.15,
    transform: "translate(451.16 125.33) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M332.36,123.86a1.92,1.92,0,0,0,1.91-1.86v.06a1.92,1.92,0,1,1-3.83,0s0,0,0-.06A1.91,1.91,0,0,0,332.36,123.86Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332.36,120h0a1.9,1.9,0,0,1,1.91,1.91h0a1.91,1.91,0,0,1-1.91,1.92h0a1.92,1.92,0,0,1-1.92-1.92h0A1.91,1.91,0,0,1,332.36,120Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 6.78,
    height: 6.78,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216.94,123.86A1.93,1.93,0,0,1,215,122v.06a1.92,1.92,0,1,0,3.83,0s0,0,0-.06A1.91,1.91,0,0,1,216.94,123.86Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.94,120h0a1.91,1.91,0,0,0-1.91,1.91h0a1.92,1.92,0,0,0,1.91,1.92h0a1.92,1.92,0,0,0,1.92-1.92h0A1.91,1.91,0,0,0,216.94,120Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 328.97,
    y: 243.95,
    width: 6.78,
    height: 6.78,
    rx: 0.15,
    transform: "translate(451.16 376.13) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M332.36,249.26a1.92,1.92,0,0,0,1.91-1.86v.07a1.92,1.92,0,0,1-3.83,0s0,0,0-.07A1.91,1.91,0,0,0,332.36,249.26Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332.36,245.43h0a1.9,1.9,0,0,1,1.91,1.91h0a1.91,1.91,0,0,1-1.91,1.92h0a1.92,1.92,0,0,1-1.92-1.92h0A1.91,1.91,0,0,1,332.36,245.43Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 125.4,
    width: 6.78,
    height: 6.78,
    rx: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216.94,249.26A1.93,1.93,0,0,1,215,247.4v.07a1.92,1.92,0,0,0,3.83,0s0,0,0-.07A1.91,1.91,0,0,1,216.94,249.26Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.94,245.43h0a1.91,1.91,0,0,0-1.91,1.91h0a1.92,1.92,0,0,0,1.91,1.92h0a1.92,1.92,0,0,0,1.92-1.92h0A1.91,1.91,0,0,0,216.94,245.43Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "55.7 29.02 12.13 29.02 13.96 27.1 53.86 27.1 55.7 29.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "55.7 20.46 12.13 20.46 13.96 22.38 53.86 22.38 55.7 20.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.86 27.1 53.86 22.38 55.7 20.46 55.7 29.02 53.86 27.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "12.13 29.02 13.96 27.1 13.96 22.38 12.13 20.46 12.13 29.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "66.5 29.02 110.07 29.02 108.23 27.1 68.33 27.1 66.5 29.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "66.5 20.46 110.07 20.46 108.23 22.38 68.33 22.38 66.5 20.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "68.33 27.1 68.33 22.38 66.5 20.46 66.5 29.02 68.33 27.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "110.07 29.02 108.23 27.1 108.23 22.38 110.07 20.46 110.07 29.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 13.96,
    y: 46.81,
    width: 94.27,
    height: 68.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.05 63.22 99.63 90.49 99.6 91.67 99.44 102.14 99.39 105.73 99.31 111.98 92.5 112.03 88.6 112.06 33.96 112.43 30.11 112.45 22.15 112.51 22.2 108.81 22.23 106.73 22.25 105.25 22.31 101.75 22.49 90.49 22.52 88.69 22.52 88.4 22.54 87.48 22.89 63.72 35.25 50.11 61.26 49.93 62.15 49.93 88.08 49.74 96.14 58.81 97.46 60.32 100.05 63.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.04 63.23 99.62 90.5 22.48 90.5 22.88 63.73 35.24 50.12 88.06 49.75 96.14 58.82 97.45 60.33 100.04 63.23"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 263.68,
    cy: 190.76,
    r: 14.75,
    transform: "translate(-195.22 286.03) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.1,192.21s-5.51,4.55-10.41,1.6a4.18,4.18,0,0,1-2-3.91,5.3,5.3,0,0,1,2.05-3.92,2.7,2.7,0,0,1,3.6.22,12.11,12.11,0,0,0,6.81,3.14l1.54,1.42Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.14,192.35s4.55,5.51,1.6,10.41a4.18,4.18,0,0,1-3.91,2,5.28,5.28,0,0,1-3.92-2,2.69,2.69,0,0,1,.22-3.6,12.11,12.11,0,0,0,3.14-6.81l1.42-1.54Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.26,189.3s5.51-4.55,10.42-1.6a4.18,4.18,0,0,1,2,3.91,5.34,5.34,0,0,1-2.05,3.92,2.7,2.7,0,0,1-3.61-.22,12.07,12.07,0,0,0-6.81-3.14l-1.53-1.42Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.23,189.17s-4.55-5.52-1.6-10.42a4.18,4.18,0,0,1,3.91-2,5.33,5.33,0,0,1,3.92,2.05,2.7,2.7,0,0,1-.23,3.61,12.13,12.13,0,0,0-3.13,6.81l-1.42,1.53Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 263.68,
    cy: 190.76,
    r: 4.88,
    transform: "translate(-195.3 285.94) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M266.25,190.8a2.57,2.57,0,1,1-2.52-2.61A2.55,2.55,0,0,1,266.25,190.8Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.71,
    y: 190.49,
    width: 31.95,
    height: 0.52,
    transform: "translate(-145.07 332.62) rotate(-89.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 263.42,
    y: 174.78,
    width: 0.52,
    height: 31.95,
    transform: "translate(-145.07 332.62) rotate(-89.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264,175a15.72,15.72,0,1,0,15.45,16A15.75,15.75,0,0,0,264,175Zm-.54,32a16.24,16.24,0,1,1,16.51-16A16.26,16.26,0,0,1,263.41,207Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.91,177.52a13.24,13.24,0,1,0,13,13.46A13.25,13.25,0,0,0,263.91,177.52Zm-.46,27a13.76,13.76,0,1,1,14-13.53A13.78,13.78,0,0,1,263.45,204.52Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.87,180a10.76,10.76,0,1,0,10.57,10.94A10.77,10.77,0,0,0,263.87,180Zm-.38,22A11.29,11.29,0,1,1,275,191,11.29,11.29,0,0,1,263.49,202Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.82,182.47A8.29,8.29,0,1,0,272,190.9,8.31,8.31,0,0,0,263.82,182.47Zm-.29,17.09a8.81,8.81,0,1,1,9-8.65A8.81,8.81,0,0,1,263.53,199.56Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.78,185a5.81,5.81,0,1,0,5.71,5.91A5.81,5.81,0,0,0,263.78,185Zm-.2,12.14a6.34,6.34,0,1,1,6.43-6.23A6.34,6.34,0,0,1,263.58,197.09Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M263.74,187.42a3.34,3.34,0,1,0,3.27,3.39A3.34,3.34,0,0,0,263.74,187.42Zm-.12,7.19a3.86,3.86,0,1,1,3.92-3.79A3.85,3.85,0,0,1,263.62,194.61Z",
    transform: "translate(-213.55 -118.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 22.53,
    y: 92,
    width: 77.07,
    height: 2.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "33.96 112.43 30.11 112.45 26.58 109.24 26.58 109.21 26.5 109.16 26.5 109.13 26.42 109.05 26.32 108.97 26.16 108.81 26 108.68 25.71 108.42 23.86 106.73 22.25 105.25 22.31 101.75 27.26 106.28 27.63 106.63 27.74 106.73 29.61 108.44 30.03 108.81 30.56 109.31 31.01 109.71 31.22 109.89 31.59 110.26 31.83 110.45 32.22 110.84 33.96 112.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "99.44 102.14 99.39 105.73 96.14 108.71 96.04 108.81 96.01 108.81 94.64 110.08 92.5 112.03 88.6 112.06 90.76 110.08 92.16 108.81 94.43 106.73 96.14 105.17 99.44 102.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "96.04 108.82 25.75 107.78 22.21 101.75 99.44 102.14 96.04 108.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 76,
    y: 58.94,
    width: 1.65,
    height: 29.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 80.95,
    y: 58.94,
    width: 1.65,
    height: 29.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 85.89,
    y: 58.94,
    width: 1.65,
    height: 29.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf);
export default __webpack_public_path__ + "static/media/RF.b0d8c18e0c337382e1e98098dc6224ef.svg";
export { ForwardRef as ReactComponent };